import $ from 'jquery'

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if( $('[js-menu-country]').length ){
      $('[js-menu-country]').click(function(){
        const $el = $(this)
        const country_slug = $el.attr('js-menu-country')
        var event = new CustomEvent('tx.filter.willUpdate', {
          detail:{
            param:{
              airlines:'',
              filter_country_slug: country_slug,
            }
          }
        })
        document.dispatchEvent(event);
      })
    }

    if( $('[js-menu-airlines]').length ){
      $('[js-menu-airlines]').click(function(){
        const $el = $(this)
        const airlines = $el.attr('js-menu-airlines')
        var event = new CustomEvent('tx.filter.willUpdate', {
          detail:{
            param:{
              airlines: airlines,
              filter_country_slug: '',
            }
          }
        })
        document.dispatchEvent(event);
      })
    }
  },
};
